import { useEffect } from "react";
import { DefaultComponentProps, Dialog, DialogContent, DialogTitle, DialogActions, FlexGrid, Typography, Button } from "@albo-ui/core";
import { useAddTask } from "./hooks/useAddTask";
import { TextField, Box } from "@mui/material";
import { Info } from "@mui/icons-material";
import moment from "moment";
moment.locale("es");

export type ManageEventDialogProps = {
    item: any;
    open: boolean;
    onClose: () => void;
    onConfirm: (data: any) => void;
} & DefaultComponentProps;

export const ManageEvent = ({ item, open, onClose, onConfirm }: ManageEventDialogProps) => {
    const { form, isValid, onHandleChange } = useAddTask(open, item, onConfirm);

    useEffect(() => {
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const init = async () => {
        await document;
        if (document.getElementById("datePickerId")) {
            let datePickerId = document.getElementById("datePickerId");
            datePickerId["min"] = new Date().toISOString().slice(0, 16);

            var date = new Date();
            var newDate = new Date(date.setMonth(date.getMonth() + 6));
            datePickerId["max"] = new Date(newDate).toISOString().slice(0, 16);
        }
    };

    return (
        item && (
            <Dialog onClose={onClose} open={open} style={{minWidth: 600, maxHeight: 500}}>
                <DialogTitle>
                    <Typography variant='h2'>{item['tooltip']}</Typography>
                </DialogTitle>

                <DialogContent>
                    <Info fontSize='small' color='primary' sx={{ mr: 0.5, verticalAlign: "sub" }}/><Typography variant='small' color='primary'>Selecciona la fecha y hora para programar tu evento</Typography>
                    <Box mt={5} mb={0.5}>
                        <TextField id="datePickerId" value={form["edate"] || ""} onInput={onHandleChange.bind(this, "edate")} InputLabelProps={{ shrink: true }} type={"datetime-local"} style={{ cursor: "pointer" }} color="secondary" label="Fecha" />
                    </Box>
                    <Box mt={2} mb={0.5}>
                        <TextField value={(form["description"] || "")} onInput={onHandleChange.bind(this, "description")} label="Nombre del evento" fullWidth/>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }}>
                        <FlexGrid item>
                            <Button onClick={onClose} buttonType="secondary" size="normal">Cancelar</Button>
                        </FlexGrid>
                        <FlexGrid item>
                            <Button onClick={onConfirm.bind(this, form)} disabled={isValid} size="normal" >Aceptar</Button>
                        </FlexGrid>
                    </FlexGrid>
                </DialogActions>
            </Dialog>
        )
    );
};
